<template>
  <div fluid fill-height>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>

    <Workflow />
  </div>
</template>

<script>
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
import Workflow from "../../components/Workflow/Workflow.vue";
export default {
  components: { LandingToolbar, Workflow },
};
</script>
